<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" version="1.1" viewBox="0.00 0.00 640.00 640.00">
    <path
      d="
    M 0.00 349.66
    L 0.00 289.96
    Q 2.25 276.00 16.28 273.67
    Q 36.68 270.28 57.04 267.02
    Q 57.87 266.88 58.04 266.07
    Q 68.14 218.33 94.81 177.55
    A 1.13 1.13 0.0 0 0 94.78 176.29
    Q 82.57 159.29 70.70 142.76
    Q 64.58 134.23 67.31 125.34
    Q 68.76 120.66 75.25 113.18
    Q 88.74 97.63 105.52 82.77
    C 109.87 78.92 113.89 75.02 119.22 73.62
    Q 128.29 71.22 136.42 77.07
    Q 153.23 89.17 170.05 101.25
    Q 170.52 101.58 170.99 101.27
    Q 211.72 74.53 259.46 64.43
    A 1.42 1.42 0.0 0 0 260.57 63.26
    Q 263.43 44.92 266.53 26.46
    Q 267.88 18.42 269.95 14.93
    C 276.27 4.30 288.66 5.22 301.38 4.61
    Q 309.09 4.25 312.11 10.09
    Q 313.51 12.81 313.51 18.66
    Q 313.52 58.26 313.52 97.87
    Q 313.53 104.55 312.46 106.99
    C 310.39 111.72 306.57 113.05 301.32 113.42
    Q 224.98 118.79 170.43 170.68
    C 96.94 240.58 86.02 355.00 143.70 438.00
    C 180.05 490.30 238.24 522.85 302.00 526.55
    C 310.98 527.07 313.51 532.62 313.51 540.90
    Q 313.53 581.01 313.51 621.11
    C 313.51 629.86 311.05 635.44 301.64 635.32
    Q 292.31 635.20 285.00 634.31
    Q 274.69 633.07 269.93 625.11
    Q 267.86 621.65 266.50 613.49
    Q 263.44 595.11 260.55 576.83
    A 1.40 1.40 0.0 0 0 259.46 575.68
    Q 211.69 565.57 170.92 538.81
    A 0.69 0.69 0.0 0 0 170.15 538.83
    Q 156.30 548.74 142.50 558.68
    Q 133.08 565.47 128.79 566.60
    C 118.78 569.25 112.99 563.82 104.95 556.80
    Q 86.45 540.63 71.52 522.51
    Q 64.78 514.33 67.19 504.83
    Q 68.13 501.11 72.13 495.47
    Q 83.34 479.69 94.72 463.97
    A 1.27 1.26 -43.6 0 0 94.76 462.53
    Q 68.04 421.64 57.98 373.79
    A 0.80 0.79 -1.0 0 0 57.33 373.17
    Q 39.52 370.29 21.83 367.35
    Q 12.27 365.76 8.68 363.59
    Q 1.32 359.14 0.00 349.66
    Z"
    />
    <path
      d="
    M 422.24 90.25
    Q 422.47 123.37 422.25 156.50
    C 422.15 171.48 412.86 184.07 398.63 188.09
    Q 393.47 189.55 381.74 189.53
    Q 359.06 189.50 336.23 189.57
    A 0.89 0.89 0.0 0 1 335.34 188.68
    L 335.34 168.35
    Q 335.34 167.79 335.90 167.79
    Q 360.65 167.73 385.37 167.75
    Q 391.92 167.76 394.44 166.59
    C 399.02 164.47 400.51 160.61 400.51 155.44
    Q 400.53 122.77 400.56 90.11
    Q 400.56 89.58 400.07 89.37
    C 375.36 79.16 371.15 47.19 393.20 31.69
    C 407.87 21.37 428.97 26.02 438.63 40.74
    C 448.52 55.81 444.71 74.64 430.18 85.48
    C 428.09 87.04 425.28 88.23 422.71 89.48
    Q 422.23 89.71 422.24 90.25
    Z"
    />
    <path
      d="
    M 531.03 187.95
    Q 531.31 217.21 531.04 246.50
    Q 531.01 249.33 529.80 253.16
    C 526.48 263.72 518.43 271.90 508.13 274.95
    Q 502.85 276.52 488.72 276.52
    Q 412.36 276.48 336.16 276.51
    A 0.80 0.80 0.0 0 1 335.36 275.71
    L 335.31 255.33
    Q 335.31 254.77 335.88 254.77
    Q 416.14 254.74 496.35 254.76
    Q 500.91 254.76 503.42 253.48
    C 510.30 249.95 509.43 244.24 509.46 236.04
    Q 509.55 212.02 509.46 187.99
    A 0.78 0.78 0.0 0 0 508.98 187.27
    C 470.78 171.91 488.40 116.46 528.00 124.93
    Q 534.84 126.39 540.63 131.12
    C 560.63 147.46 555.15 178.42 531.45 187.35
    A 0.65 0.64 -10.7 0 0 531.03 187.95
    Z"
    />
    <path
      d="
    M 186.32 422.43
    C 127.09 349.98 143.01 240.66 218.84 187.09
    Q 255.21 161.40 300.75 157.34
    Q 308.99 156.61 312.08 162.28
    Q 313.52 164.91 313.52 170.98
    Q 313.50 319.75 313.52 468.51
    Q 313.52 475.21 312.19 477.77
    C 309.71 482.55 305.10 483.29 299.78 482.76
    Q 229.90 475.74 186.32 422.43
    Z"
    />
    <path
      d="
    M 335.33 212.16
    A 0.96 0.96 0.0 0 1 336.29 211.20
    L 443.58 211.20
    A 11.37 10.82 -0.0 0 1 454.95 222.02
    L 454.95 222.22
    A 11.37 10.82 0.0 0 1 443.58 233.04
    L 336.29 233.04
    A 0.96 0.96 0.0 0 1 335.33 232.08
    L 335.33 212.16
    Z"
    />
    <path
      d="
    M 640.00 318.35
    L 640.00 321.75
    C 637.13 356.82 589.74 364.27 576.97 331.55
    A 1.06 1.06 0.0 0 0 575.98 330.87
    L 336.88 330.91
    A 1.54 1.53 -0.0 0 1 335.34 329.38
    L 335.35 309.81
    Q 335.35 309.22 335.94 309.22
    L 576.13 309.22
    A 0.86 0.85 -78.6 0 0 576.92 308.69
    C 584.78 289.70 605.41 281.77 623.38 291.72
    Q 637.93 299.78 640.00 318.35
    Z"
    />
    <path
      d="
    M 509.44 452.06
    Q 509.60 426.02 509.46 399.98
    Q 509.42 393.47 507.92 390.77
    C 505.29 386.06 500.99 385.29 495.50 385.30
    Q 417.62 385.42 339.75 385.38
    Q 337.41 385.38 336.05 385.25
    Q 335.33 385.18 335.33 384.45
    L 335.33 364.28
    Q 335.33 363.59 336.02 363.59
    Q 417.17 363.62 498.24 363.79
    C 516.44 363.83 530.71 377.44 530.89 395.75
    Q 531.17 423.86 531.13 451.97
    Q 531.13 452.50 531.61 452.73
    C 534.25 453.94 536.96 455.19 539.18 456.83
    C 553.13 467.13 557.57 486.84 547.50 501.50
    C 536.35 517.73 514.42 520.81 499.30 508.32
    C 479.54 491.99 486.13 462.25 508.96 452.77
    Q 509.43 452.57 509.44 452.06
    Z"
    />
    <path
      d="
    M 335.32 408.15
    A 0.89 0.89 0.0 0 1 336.21 407.26
    L 443.57 407.08
    A 11.37 10.80 -0.1 0 1 454.96 417.86
    L 454.96 418.10
    A 11.37 10.80 -0.1 0 1 443.61 428.92
    L 336.25 429.10
    A 0.89 0.89 0.0 0 1 335.36 428.21
    L 335.32 408.15
    Z"
    />
    <path
      d="
    M 400.55 549.91
    Q 400.54 517.41 400.51 484.93
    C 400.50 477.85 397.14 472.43 389.51 472.45
    Q 362.60 472.49 335.89 472.46
    A 0.54 0.54 0.0 0 1 335.35 471.92
    L 335.35 451.28
    Q 335.35 450.64 335.99 450.63
    Q 358.25 450.42 380.43 450.56
    Q 394.60 450.65 399.89 452.33
    C 413.25 456.57 422.34 469.48 422.32 483.75
    Q 422.29 516.88 422.30 550.01
    A 0.81 0.79 -79.3 0 0 422.80 550.76
    C 439.12 557.27 448.17 574.90 442.55 591.27
    C 435.50 611.80 411.90 620.54 393.48 608.51
    C 373.41 595.41 374.52 567.05 393.87 553.91
    C 395.57 552.75 397.97 551.78 400.06 550.71
    Q 400.55 550.46 400.55 549.91
    Z"
    />
  </svg>
</template>
